import { Navigate } from "react-router";
import { useBookDetail } from "./bookContext";
import { bookLandingPath } from "./landing";

/**
 * /books/:id with no screen named: the step this Book's state makes worth
 * opening. A Failed Book lands on the overview, where the retry is; every
 * other state lands where the Author left off, which is what a bookmarked
 * Book id and the dashboard's own card both do.
 */
export function BookIndex() {
  const book = useBookDetail();
  return <Navigate to={bookLandingPath(book.id, book.state)} replace />;
}
